<template>
    
    <div class="mint_container">

        <img class="maneki-logo" src="../../src/assets/images/logo-maneki_logo.png" v-on:click="goHome()"/>

        <!-- Wallet connectd -->
        <div v-if="isConnect" class="wallet-connection"  >
            <div class="token-wrap">

                <div class="cfx-balance">{{Account.coinBalance/1e18}} CFX</div>
                <div class="neko-balance">{{Account.tokenBalance/1e18}} NEKO</div>
                <div  style="float:left;font-size:0.6em; color:#666;"> Conflux Network : {{accAddressStorten}} </div>
            </div>
        </div>


        <!-- Wallet not connected -->
        <div v-if="!isConnect" class="wallet-connection"  >
            <div class="token-wrap">
                <div class="cfx-balance"> Conflux networks</div>
                <el-button 
                    style="font-size:1.2em; margin-top:-5px; background-color:#ffe000; color:#ff3600; border:1px solid #ff3600;" 
                    @click="connectButton()"> Connect wallet
                </el-button>
            </div>
        </div>




        <div class="content-tab">

        <div class="tab-game" v-if="isTabGame">
            <div class="games_details">
                <div class="pool_neko">{{game.tokenPoolReward}} </div>
                <div class="pool_cfx">{{game.coinPoolReward}} </div>

                <div class="live-display" @click="playBgMusic()">
                    {{ life }} 
                </div>
                <el-image @click="goTabMetapass()"
                    style="max-width:165px; max-height:90px;  margin-top:15px; margin-left:65px;  " :src="nftImageURL" >

                    <div slot="placeholder" class="image-slot">
                        Loading<span class="dot">...</span>
                    </div>
                    <div slot="error" class="image-slot"  @click="goTabMetapass()" >
                        <div class="el-icon-picture"></div>
                    </div>
                
                </el-image>

                <div class="latestWinner" v-if="latestWinner.length >2">
                        {{latestWinner[ (latestWinner.length - 3)].metapass}}
                        {{latestWinner[ (latestWinner.length - 2)].metapass}}
                        {{latestWinner[ (latestWinner.length - 1)].metapass}}
                </div>
                
            </div>
            <div class="panel-play">

                <div class="metapass_status">
                    <div v-if="isOwner"> 
                        <span style="background:#12bc00; padding:3px 20px; border-radius: 20px; color:white;">
                        MEOW #{{ metaPass }} ✔
                        </span>
                    </div>

                    <div v-if="!isOwner && metaPass!=10010" > 
                        <span style="background:#ff4e00; padding:3px 25px; border-radius: 20px; color:white;">
                        Not yours ✖
                        </span>
                    </div>

                    <div v-if="!isOwner && metaPass==10010" > 
                        METAPASS-ONLY
                    </div>
                </div>


                <div class="round_details">
                    <div class="win_count">
                        x {{winCount}}
                    </div>
                    <div class="tokenDebit"> 
                        {{tokenDebit}}
                    </div>

                </div>
                <ul class="doors">
                    <li :class ="item.color"  v-for="(item) in doors" :key="item.id" >
                            <div @click="openThisRoom(item.id)" >{{item.id + 1}} </div>
                    </li>

                    <div style="clear:both;"></div>
                </ul>
            </div>

        </div>


        <div class="tab-metapass" v-if="isTabMetapass">
                <h2> Metapass 
                    <div class="meow-balance">{{accountNFTBalance}}</div>
                </h2> 
                <ul>
                <li v-for="(item2) in myPass" :key="item2.id" >
                        <div style="padding:8px 5px;" @click="selectMetapass(item2.id)" > MEOW #{{item2.id}} <span style="float:right; color:red;"> ♥ 5 </span></div>

                        <el-image style="max-width:180px; max-height:180px; border-radius: 5px; " :src="item2.img" :fit="'cover'" @click="selectMetapass(item2.id)" >

                            <div slot="placeholder" class="image-slot">
                                Loading<span class="dot">...</span>
                            </div>
                            <div slot="error" class="image-slot">
                                <div class="el-icon-picture"></div>
                            </div>
                        
                        </el-image>
                </li>

                <div style="clear:both;"></div>
                </ul>

        </div>

        <div class="tab-koban" v-if="isTabKoban">
            <div class="koban-winners">
                <ul>
                <li v-for="(item2, index) in lastestCombos" :key="index" >
                        <div> {{item2.metapass}} </div>
                        <div> {{item2.winnerWallet}} </div>
                        <div> Koban value : {{ item2.tokenPool/1e18}}NEKO   Bonus : {{ item2.coinPool/1e18 }}CFX </div> 
                </li>
                    <div style="clear:both;"></div>
                </ul>
            </div>
        </div>

        <div style="clear:both;"></div>
        </div>

 
        \
        <el-dialog :visible.sync="dialogMetapassExpired" class="dialog-container">

            <div class="dialog-wrap"  @click="dialogLuckyItem = false">
                <img src="../../src/assets/images/ManekiGames_icon-lose.png" /> <br>
                {{life}} ♥ <br>
                4 mins
                <el-button @click="changeMetapass()"> change metapass </el-button>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="dialogLuckyItem" class="dialog-container">

            <div class="dialog-wrap"  @click="dialogLuckyItem = false">
                <img src="../../src/assets/images/ManekiGames_icon-win.png" /> <br>
                {{winCount}} Lucky Fish
            </div>
        </el-dialog>


        <el-dialog :visible.sync="dialogFishbone" class="dialog-container" >

            <div class="dialog-wrap"  @click="dialogFishbone = false">
                <img src="../../src/assets/images/ManekiGames_icon-lose.png" /><br>
                {{life}} ♥ 
            </div>
        </el-dialog>

        <el-dialog :visible.sync="dialogSubmit" class="dailog_wish">
            <div class="dialog-input-wrap">
                <div style="text-align: center; color:white; font-size: 2em;">
                Save {{tokenDebit}} NEKO to piggy banks
                </div>
                <el-button @click="submitForRewards()">
                    Save now
                </el-button>
            </div>
        </el-dialog>

 
        <el-dialog :visible.sync="dialogLose" class="dailog_wish">

            <div class="dialog-input-wrap">
                <div style="text-align: center; color:white; font-size: 2em;">
                Door : {{ roomOpened }}<br>
                You lose <br>
                - NEKO {{ tokenDebit }}
            </div>
            </div>
        </el-dialog>


        <!-- Download wallet -->
        <el-dialog  :visible.sync="downloadWallet">

            <div class="dialog-input-wrap">


                <div class="dialog-content" style="height:250px;">
                    <div style="margin: 0 auto; color:white; font-size:1.6em; text-align:center; padding-top:50px; padding-bottom:5px; width:350px; ">
                        <span style="color:yellow; font-size:0.8em;">Maneki-MeowをConfluxウォレットで<br>安全にチェーンに保管する</span><br>
                        Store Maneki-Meow <br>safely on-chain with
                        <br>
                        <img  style="margin-top:30px; width:220px; background:white; border-radius:5px; padding:20px;" src="https://fluentwallet.com/assets/logo.b3425fdb.svg"  />
                    </div>
                </div>

                <div slot="footer" class="dialog-footer">
                    <el-button style="font-size:1.2em; margin-top:30px; background-color:#ffe000; color:#ff3600; border:1px solid #ff3600; "  > 
                        <a href="https://chrome.google.com/webstore/detail/fluent/eokbbaidfgdndnljmffldfgjklpjkdoi" target="_blank">
                            Free downlaod
                        </a>
                    </el-button>
                        <div style="color:#CCC;padding-top:5px;"> for Chrome </div>
                    <div style="margin-top:60px;"> 
                        New to Conflux? 
                        <a href="https://fluentwallet.com/" target="_blank"> Learn more about wallets</a>
                    </div> 
                </div>

            </div>
        </el-dialog>

      <!-- Install Fluent -->
        <el-dialog  :visible.sync="dialogInstall" :close-on-click-modal="false" >
            <div class="dialog-input-wrap">
                <div class="dialog-content">
                    <div style="color:white; font-size:1.8em; padding-top:120px; padding-bottom:20px; width:350px; margin:0 auto; "> 
                        <span style="color:yellow; font-size:0.7em;"></span> Connect to a wallet
                    </div>
                    <div class="walletButton">
                    <a href="https://fluentwallet.com/" target="_blank" >
                        <div style="width:250px; height:35px; color:black; font-size:1.7em; font-weight:100; float:left; "> Install Fluent Wallet </div>
                        <img style="width:35px; float:left; " src="../../src/assets/images/fluent-logo.png" />
                    </a>
                    </div>
                    <div style="color:#666; font-size:1em; padding-top:80px; width:350px; margin:0 auto; "> 
                        New to Conflux? <a href="https://fluentwallet.com/" target="_blank" style="color:#666;"> Learn more about wallet </a>
                    </div>
                </div>
            </div>
        </el-dialog>

      <!-- Activate address Fluent -->
        <el-dialog  :visible.sync="dialogActivate" :close-on-click-modal="false" >
            <div class="dialog-input-wrap">
                <div class="dialog-content">
                    <div style="color:white; font-size:1.8em; padding-top:120px; padding-bottom:20px; width:350px; margin:0 auto; "> 
                        <span style="color:yellow; font-size:0.7em;"></span> Connect to a wallet
                    </div>
                    <div class="walletButton" @click="authorizedWallet()">
                        <div style="width:250px; height:35px; color:black; font-size:1.7em; font-weight:100; float:left; "> Fluent Wallet </div>
                        <img style="width:35px; float:left; " src="../../src/assets/images/fluent-logo.png" />
                    </div>
                    <div style="color:#666; font-size:1em; padding-top:80px; width:350px; margin:0 auto; "> 
                        New to Conflux? <a href="https://fluentwallet.com/" target="_blank" style="color:#666;"> Learn more about wallet </a>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
    
</template>

<script>


// Contract : Collectibles 
//import abi_collectible from '../web3/abi_collectible';
import abi_nft_meow from '../web3/abi_nft_meow';
import abi_beckoning from '../web3/abi_beckoning';
import abi_neko from '../web3/abi_neko';

//Conflux SDK
const { format,Conflux } = require('js-conflux-sdk');

// First Network - Conflux Core Testnet
// run games
const conflux = new Conflux({
  url: 'https://test.confluxrpc.com',
  networkId: 1,
});

const provider = window.conflux

console.log(' connected Wallet and network : ',provider)


//const contract_collectibles =  conflux.Contract({
//    abi:abi_collectible, 
//    address:'cfxtest:ach87yxtp3a2j88s6v4ca53dy9hzn1tcxpe9fm17pm'
//});

const contract_neko = conflux.Contract({
    abi:abi_neko, 
    address:'cfxtest:acge2agcv2hfkvsdb5nud5reh0bx953r5pxb7d7wb6'
});

const contract_beckoning = conflux.Contract({
    abi:abi_beckoning, 
    address:'cfxtest:acg7t0famkfebucg9d778r1s3f2newd5u23dvj0j1a'
});

// end first Network 



// Secind Network - Conflux Core Mainnet
// use to get Meow as Metapass
const confluxCore = new Conflux({
  url: 'https://main.confluxrpc.com',
  networkId: 1029,
});

const contract_nft_meow =  confluxCore.Contract({
    abi:abi_nft_meow, 
    address:'cfx:acedfgnc6tp0g8t2yy35gmr4pw4cjk7sgus4fmktnn'
});




const path_Image = 'https://m.maneki.market/';

//const path_TxLogURL = 'https://testnet.confluxscan.io/transaction/';
//const path_Metadata = 'https://t2metadata.maneki.market/token/'



export default {
  name: 'App',
  data() {
    return {
        grid : 5,
        authKey : '0x000000000000000000000000697cb3a91d22f4cb39aeea7eb4a410fedd0bbe06',
        metaPass : 10010,
        timer : 0,
        tokenDebit : 0,
        life : 3,

        isTabGame : true,
        isTabMetapass : false,
        isTabKoban : false,
        isPlay : true,

        game :{
            range           :1, 
            coinPoolReward  :0, 
            tokenPoolReward :0,
            coinFactor      :0, 
            tokenFactor     :0, 
            tokenAddress    :0
        },

        myPass : [],
        doors : [],
   
        round : [],

        collectedNeko :[],

        latestWinner : [],

        lastestCombos : [],

        winCount:0,
        totalRounds :0,
        roomOpened : 0,
        isGameOver : false,


        dialogSubmit : false,
        dialogWin : false,
        dialogLose : false,
        dialogLuckyItem : false,
        dialogFishbone : false,
        dialogMetapassExpired : false,
        
        initLoad : false,
        timeDisplay : '',
        clock:0,
        countDownDate : 0,

        Account : {
            playerWallet: '',
            tokenAmount : 0,
            coinAmount  : 0
        },


        isConnect: false,
        accountCFXBalance : 0,
        accountNekoBalance : 0,
        accountNFTBalance : 0,
        accAddress : '0x0',
        accAddressStorten : '0x0',
        dialogInstall : false,
        dialogActivate : false,
        nftImageURL : '',
        
        isMetapass : false,
        isOwner : false,

        endDuration : 40,
        endProgress : 0,


        web3: null,
        account:null,
        poolBalance:0,
        selected : 0,
        display :{
            isConnect : false,
            isGuardian : true,
            isName : false,
            isWish : true,
            isPayment : false,
        },
        NFT : {
            owned:0,
            supply:0,
            balance:0
        },
        contract :{
            collectibles:null,
            payment:null,
            neko:null,
            ERC20:null
        },
        payment : {
            tokens : [],
            key : 0,
        },
        dialog :{
            mint :false,
            success: false,
            gamma : false,
            wish : false,
            name : false,
            payment : false,
            painting : false,
            redeem : false,
        },
        dialogTableVisible: false,
        form: {
            name: '猫の守護者',
            guardian: '',
            payment: '',
            wish: '',
        },
        newNFT : {
            id: '',
            img: '',
            wish: '',
            name: '',
            guardian : '',
            guardianIMG :'',
            DNA: '',
            gammaID: '',
            power: '',
            refCount: '',
        },
        wishRules: {
                wish: [
                    { required: true, message: 'Please make a wish', trigger: 'blur' },
                    { min: 0, max: 110, message: 'Message within 5 to 110 charaters', trigger: 'blur' }
                ],
        },    
        nameRules: {
                name: [
                    { required: true, message: 'Give a name', trigger: 'blur' },
                    { min: 0, max: 20, message: 'Message within 3 to 20 charaters', trigger: 'blur' }
                ],
        },  
        paymentRules : {
                payment: [
                    { required: true, message: 'select a payment token', trigger: 'change' }
                ]
        },          
        formLabelWidth: '120',
        downloadWallet: false,
    };
  },
  created() {
        this.form.payment = 0;
  },
  mounted() {

      this.endDateCount()

        this.initWallet();
 
        provider.on('accountsChanged', accounts => {
            this.accAddressStorten= accounts[0]
            this.initWallet()
            this.isConnect = true
            this.dialogActivate = false
            console.log('accountsChanged = ', accounts)
        })
 
        provider.on('chainChanged', chainId => {
            console.log('chainChanged,  = ', chainId)
            provider.request({method: 'cfx_netVersion'}).then(networkId => {
            console.log('networkId,  = ', networkId)
            })
        })

  },
  methods:{ 

        playBgMusic (){

         var audio = new Audio('../../src/assets/music/bgmusic-sakura.mp3'); 
         audio.play();
        },
        openNotification(_message ) {
            this.$notify.success({
            title: 'Door ' + (this.roomOpened + 1),
            message: _message,
            offset: 100,
            duration : 10000,
            position: 'top-left'
            });
        },

        endDateCount(){

            const date = new Date();

            let day = date.getDate();
            let month = date.getMonth() + 1;
            let year = date.getFullYear();

            // This arrangement can be altered based on how we want the date's format to appear.
            let currentDate = `${month}/${day}/${year}`;

            const date1 = new Date('10/25/2022');
            const date2 = new Date(currentDate);
            const diffTime = Math.abs(date2 - date1);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
            console.log(diffTime + " milliseconds");
            console.log(diffDays + " days");

            this.endProgress = diffDays
        },
        gotoSupportChat(){
             window.open('https://telegram.me/maneki2699', '_blank');
            //window.location.href = "https://telegram.me/maneki2699";
            
        },
        initWallet(){
            
            // Fluent Extention Installed?
            if (window?.conflux?.isFluent) {
                // Installed
                this.walletInitialized()
            } else {
                //Fluent Not install, Request to make installation
                console.log('Fluent is not connected, please try refresh this page or restart your browser.')
                // Appear dialog , LINK - request install Fluent 
                //this.dialogInstall = true
            }
        },
        connectButton(){
            
            // Fluent Extention Installed?
            if (window?.conflux?.isFluent) {
                // Installed, Request authorized with wallet
                //this.walletInitialized()
                this.dialogActivate = true

            } else {
                //Fluent Not install, Request to make installation
                console.log('Fluent is not connected, please try refresh this page or restart your browser.')
                // Appear dialog , LINK - request install Fluent 
                this.dialogInstall = true
            }
        },

        goMarketplace(){
            window.location.href = 'https://art.maneki.market/#/marketGroup/550000/650000';
        },
        goCollection(){
            window.location.href = 'https://art.maneki.market/#/wallet';
        },
        async authorizedWallet(){
            console.log('Requesting account')
            provider
            .request({
            method: 'cfx_requestAccounts',
            })
            .then(this.walletInitialized())
            .catch(error => console.error('error', error.message || error))
        },


        async walletInitialized() {
            console.log('Fluent Wallet Connected')

            provider.request({method: 'wallet_getFluentMetadata'}).then(({version}) => {
                console.log('Fluent version :',version);
            })

            const [chainId, networkId, alreadyAuthedAddresses] = await Promise.all([
            provider.request({method: 'cfx_chainId'}),
            provider.request({method: 'cfx_netVersion'}),
            provider.request({method: 'cfx_accounts'}),
            ])

            console.log('initialized')
            console.log('chainId :',  chainId)
            console.log('networkId: ', networkId)          
            
            if (!alreadyAuthedAddresses.length) {
                // Appear Dialog - Coneect to a wallet FLUENT
                console.log ('no address',alreadyAuthedAddresses )

            } else {
                
                this.accAddress = alreadyAuthedAddresses[0]
                this.accAddressStorten  = alreadyAuthedAddresses[0]

                // convert Testnet Address to Mainnet 
                this.accMainnetCore = format.address(format.hexAddress(alreadyAuthedAddresses[0]), 1029 );
                
                console.log('Conflux-Core Testnet :', alreadyAuthedAddresses[0])
                console.log('Conflux-Core Mainnet :', this.accMainnetCore)

                this.isConnect = true
                this.fetchData()
            }            


        },

        fetchData(){


                //this.getNekoTokenBalance();
                //this.getCFXBalance();
                this.getNFTBalance();
                this.getNFTDetails();


                this.getURI();
                this.isMetapassOwner();


                //this.getRoundDetails(this.$route.params.round);

                this.getAccount();

                this.getMyMetapass();

                this.getTotalRounds();

                this.getGameDetails();
                this.newRound()
                this.generateGird()
                this.getComboWinners()
                
        },




    newRound(){


        this.round.push({
                winningRoom : Math.floor(Math.random() * 25),
                endGameRoom : 101,
                tokenWin    : 0,
                bottom      : -1,
                upper       : 101,
                status      : true
            })

        console.log('this round is :', this.round[this.round.length - 1].winningRoom + 1)

        if(this.isGameOver == true){
            this.isGameOver = false;
            this.updateGrid()
        }

    },


    async openThisRoom( _room ) { 
        // to select a metapass or as guest
        if( this.isMetapass == true && this.isPlay == true  ){
            if(this.isGameOver==false){

                this.roomOpened = _room;

                let j = this.round.length - 1;

                console.log('selected room :', _room +1)
                let targetRoom = this.round[j].winningRoom

                if(this.round[j].bottom  <= _room && this.round[j].upper >= _room){

                    if (targetRoom == _room){
                        // Win! end games
                        this.gameWin (_room);

                    } else {
                        // bottom bias check
                        if( targetRoom > this.game.range){
                            if( _room < targetRoom - this.game.range || _room > (targetRoom + this.game.range) ){
                                // safe
                                this.updateAttemptToRound (_room);

                            } else {
                                // Lose! end games
                                // reset to new round
                                this.gameOver (_room);
                            }
                        } else {       
                            if(_room > (targetRoom + this.game.range) ){
                                // safe
                                this.updateAttemptToRound (_room);

                            } else {
                                // Lose! end games
                                // reset to new round
                                this.gameOver (_room);
                            }

                        }

                    }
                } else {
                    console.log('no action!')
                }
            } else {
                this.newRound();
            }
        } else {
            this.isTabGame = false
            this.isTabMetapass = true
        }

    },


    async submitForRewards( ) { 

        if (this.isOwner==true && this.timer == 0 ) {

            const [connectedAddress] = await provider.request({method: 'cfx_accounts'})
                
            // eestimate transaction
            const pre_tx = {
                from: connectedAddress,
                to: contract_beckoning.address,
                gas: '0x1e047', // 121000  0x1d8a8, 119399 Ox1d267 , 95981 0x176ed, 122270 0x1dd9e, 123000 0x1e078
                storageLimit: '0x200', // 256 100 , 448 0x1c0, 384 0x180, 704 0x2c0, 512 0x200
                gasPrice: '0x3b9aca00', //1000000
                data: contract_beckoning.submit( this.authKey, this.metaPass, this.tokenDebit
                ).data,
            }

            provider.request({ method: 'cfx_estimateGasAndCollateral', params: [pre_tx]})
            .then((estimation) => { 
                this.gasLimit = estimation['gasLimit']
                this.gasUsed = estimation['gasUsed']
                this.storageCollateralized = estimation['storageCollateralized']
                console.log('gas estimaation , ', estimation)
            });


            // send transaction
            const tx = {
                from: connectedAddress,
                to: contract_beckoning.address,
                gas: this.gasLimit, 
                storageLimit: this.storageCollateralized, 
                gasPrice: '0x3b9aca00', //1000000
                data: contract_beckoning.submit( this.authKey, this.metaPass, this.tokenDebit
                ).data,
            }


            provider.request({ method: 'cfx_sendTransaction', params: [tx]})
            .then((txHash) => {
                
                console.log("txHash: ",txHash )

                setTimeout(() => {

                    provider.request({ method: 'cfx_getTransactionReceipt', params: [txHash]})
                    .then((receipt) => {
                    
                        console.log("purchase receipt", receipt)

                        this.getRoundDetails(this.$route.params.round);
                        this.setTimer ()
                        
                    }).catch((err) => {
                        console.log(err, 'err!!');
                    });
                }, 10000);

                // new round and reset token debit
                this.newRound()
                this.updateGrid()
                this.tokenDebit = 0
                this.getGameDetails()
                this.getTotalRounds()

                // reset the winning count
                 this.winCount = 0; 
                 this.dialogSubmit = false;

            })
            .catch(error => console.error('error', error.message || error))
        } else {
            console.log ('Metapass not valid. cannnot play')
            if (this.timer != 0){
                console.log ('please wait for ',this.timeDisplay)
            }
        }

    },


    updateAttemptToRound (_room){

        let j = this.round.length - 1;

        this.collectedNeko.push({
            round : j,
            nekoAMount : this.game.tokenFactor,
            room : _room
        })

        // update current round
        if( _room < this.round[j].winningRoom) {
            this.round[j].bottom     = _room;
        } else { 
            this.round[j].upper      = _room;
        }

        // update temporary holding token
        this.tokenDebit += this.game.tokenFactor

        // trigger notification 
        this.openNotification('NEKO ' + this.tokenDebit)

        this.updateGrid()
    },
    gameWin ( _room) {
        let j = this.round.length - 1;

        console.log('this round neko Collected: ', this.collectedNeko);

        // update current round 
        this.round[j].endGameRoom    = _room;
        this.round[j].status = false;

        // update temporary holding token
        this.tokenDebit += this.game.tokenFactor


        this.winCount ++; 

        // submit for rewards
        if( this.winCount == 3 ){

            this.dialogSubmit = true

        } 

        this.updateGrid()
        this.isGameOver = true;
        this.dialogLuckyItem = true;
       
    },
    gameOver ( _room) {
        let j = this.round.length - 1;

        // update current round 
        this.round[j].endGameRoom    = _room;
        this.round[j].status = false;

        this.life --

        // reset 
        if ( this.life == 0 ){
            this.tokenDebit = 0
            this.winCount = 0
            this.isPlay = false
            this.dialogMetapassExpired = true 
        } 

        this.dialogFishbone = true;
        
        // new round
        this.updateGrid()
    
        this.isGameOver = true;
    },

    async getTotalRounds(){   

    await contract_beckoning.totalRounds().then((res) => {

        this.totalRounds = res[0];


        console.log('Total rounds :', this.totalRounds);

        this.getLatestRound(this.totalRounds)

        }).catch((err) => {
            console.log(err, 'err');
        });

    },

    async getComboWinners(){   

        await contract_beckoning.totalCombos().then((res) => {

            this.totalCombos = res[0];

            for (let i= 0 ; i < this.totalCombos ; i++){
                contract_beckoning.Combos(i).then((res2) => {
                    this.lastestCombos.push({
                        winnerWallet: res2[0].toString(),
                        metapass: parseInt(res2[1]),
                        coinPool: parseInt(res2[2]),
                        tokenPool: parseInt(res2[3])
                    })

                }).catch((err) => {
                console.log(err, 'err');
                });
            }
        }).catch((err) => {
            console.log(err, 'err');
        });
    },

    async getLatestRound(_latestRound){      

            for (let i=_latestRound-3 ; i < _latestRound ; i++){
                await contract_beckoning.Rounds(i).then((res2) => {
    
                    this.latestWinner.push({
                        metapass : parseInt(res2[1])
                    })

                }).catch((err) => {
                console.log(err, 'err');
                });
            }


    },

    async getAccount (){      
        await contract_beckoning.walletBalance(this.accAddress).then((res) => {
            
            this.Account.playerWallet = res[0].toString()
            this.Account.tokenBalance = parseInt(res[1])
            this.Account.coinBalance  = parseInt(res[2])

        }).catch((err) => {
            console.log(err, 'err');
        });
    },

    async getGameDetails (){
        await  contract_beckoning.gamesDetails().call().then((res2) => {
                console.log('game details : ', res2)
                this.game.tokenPoolReward  = (parseInt(res2[0])/1e18).toFixed(0)
                this.game.coinPoolReward   = (parseInt(res2[1])/1e18).toFixed(0)
                this.game.coinFactor       = parseInt(res2[2])/1e18
                this.game.tokenFactor      = parseInt(res2[3])/1e18
                this.game.tokenAddress     = res2[4].toString()

            }).catch((err) => {
                console.log(err, 'err');
            });
        
    },
    
    async getRoundDetails (_currentRound){      
        await  contract_beckoning.Rounds(_currentRound).call().then((res2) => {

                this.round.winningRoom = parseInt(res2[0])
                this.round.endGameRoom = parseInt(res2[1])
                this.round.lastPlayer  = res2[2]
                this.round.metapass    = parseInt(res2[3])
                this.round.tokenPool   = parseInt(res2[4])
                this.round.bottom      = parseInt(res2[5])
                this.round.upper       = parseInt(res2[6])
                this.round.status      = res2[7]

                if (this.initLoad== false){
                    this.generateGird()
                } else {
                    this.updateGrid()
                }

                this.getAccount();

            }).catch((err) => {
                console.log(err, 'err');
            });

    },


    generateDoor (){
            for (let i = 0; i < 25; i++) {
                this.doors.push ({
                    id : i,
                    color : i
                })
            }
    },

    setTimer (){

        // set new active time to the particular matapass
        // generate 
        this.countDownDate = new Date().getTime() + 10000;

        console.log ('timer start :', this.countDownDate)

        this.clock = setInterval( this.startCountdown , 1000);

    },
    setCoolingTime (){


        console.log ('timer start :', this.countDownDate)

        for( let i = 0 ; i < this.myPass.length ; i++ ){

        // set Cooling time
        this.countDownDate = new Date().getTime() + 10000;

             this.myPass[i].coolingTime = this.countDownDate
            
        }


       console.log ('Cooling expired :', JSON.parse(JSON.stringify(this.myPass)))

        // add cooling time in current metapass

        // timer 
       // this.clock = setInterval( this.startCountdown , 1000);

    },
    startCountdown(){

            // Get today's date and time
            var now = new Date().getTime();

            // Find the distance between now and the count down date
            var distance = this.countDownDate - now;
            this.timer = distance;

            // Time calculations for days, hours, minutes and seconds
            //var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            //var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);

            // Display the result in the element with id="demo"
            //this.timeDisplay = days + "d " + hours + "h " + minutes + "m " + seconds + "s ";
            this.timeDisplay = minutes + "m " + seconds + "s ";



            // If the count down is finished, write some text
            if (distance < 0) {
                clearInterval(this.clock);
                this.timer = 0;
                this.timeDisplay =''
                //document.getElementById("demo").innerHTML = "EXPIRED";
            }


    },

    generateGird(){
        let j = this.round.length -1;

        if( this.round[j].status==true && this.round[j].bottom == 101 && this.round[j].upper == 101){
            // start game
            for (let i = 0; i < 25; i++) {
                this.doors.push ({
                    id : i,
                    color : 'D0'
                })
            }
        } else if (this.round[j].status==true && this.round[j].bottom != 101 && this.round[j].upper != 101) {
            // playing
            for (let i = 0; i < 25; i++) {
                if(i < this.round[j].bottom + 1 || i > this.round[j].upper - 1){
                    this.doors.push ({
                        id : i,
                        color : 'D1'
                    })
                } else {
                    this.doors.push ({
                        id : i,
                        color : 'D2'
                    })
                }
            }
        }  else if (this.round[j].status==true && this.round[j].bottom == 101 && this.round[j].upper != 101) {
            // playing
            for (let i = 0; i < 25; i++) {
                if( i > this.round[j].upper - 1){
                    this.doors.push ({
                        id : i,
                        color : 'D1'
                    })
                } else {
                    this.doors.push ({
                        id : i,
                        color : 'D2'
                    })
                }
            }
        }  else if (this.round[j].status==true && this.round[j].bottom != 101 && this.round[j].upper == 101) {
            // playing
            for (let i = 0; i < 25; i++) {
                if( i < this.round[j].bottom + 1){
                    this.doors.push ({
                        id : i,
                        color : 'D1'
                    })
                } else {
                    this.doors.push ({
                        id : i,
                        color : 'D2'
                    })
                }
            }
        } else if (this.round[j].status==false) {
            // game over
            if(this.round[j].bottom == 101){
                this.round[j].bottom = -1;
            }

            if(this.round[j].bottom != 101 && this.round[j].upper != 101){
                for (let i = 0; i < 25; i++) {
                    if(i < this.round[j].bottom + 1 || i > this.round[j].upper - 1){
                        this.doors.push ({
                            id : i,
                            color : 'D1'
                        })
                    } else {
                        this.doors.push ({
                            id : i,
                            color : 'D2'
                        })
                    }
                }
            } else {
                for (let i = 0; i < 25; i++) {
                    this.doors.push ({
                        id : i,
                        color : 'D1'
                    })        
                }
            }

            //this.game.range
            // target doors
    
            this.doors[this.round[j].winningRoom].color = 'D4'

            if (this.round[j].winningRoom == this.round[j].endGameRoom){
                this.doors[this.round[j].endGameRoom].color = 'D5A'
            } else {
                this.doors[this.round[j].endGameRoom].color = 'D5B'
            }


        }
        this.initLoad = true;
        //console.log ('the grid ', this.doors)
    },

    updateGrid(){

        let j = this.round.length - 1;

        if( this.round[j].status==true && this.round[j].bottom == 101 && this.round[j].upper == 101){
            // start game
            for (let i = 0; i < 25; i++) {
                    this.doors[i].color = 'D0'
            }
        } else if (this.round[j].status==true && this.round[j].bottom != 101 && this.round[j].upper != 101) {
            // playing
            for (let i = 0; i < 25; i++) {
                if(i < this.round[j].bottom + 1 || i > this.round[j].upper - 1){
                    this.doors[i].color = 'D1'
                } else {
                    this.doors[i].color = 'D2'
                }
            }
        }  else if (this.round[j].status==true && this.round[j].bottom == 101 && this.round[j].upper != 101) {
            // playing
            for (let i = 0; i < 25; i++) {
                if( i > this.round[j].upper - 1){
                    this.doors[i].color = 'D1'
                } else {
                    this.doors[i].color = 'D2'
                }
            }
        }  else if (this.round[j].status==true && this.round[j].bottom != 101 && this.round[j].upper == 101) {
            // playing
            for (let i = 0; i < 25; i++) {
                if( i < this.round[j].bottom + 1){
                    this.doors[i].color = 'D1'
                } else {
                    this.doors[i].color = 'D2'
                }
            }
        } else if (this.round[j].status==false) {
            // game over
            if(this.round[j].bottom == 101){
                this.round[j].bottom = -1;
            }

            if(this.round[j].bottom != 101 && this.round.upper != 101){
                for (let i = 0; i < 25; i++) {
                    if(i < this.round[j].bottom + 1 || i > this.round[j].upper - 1){

                        this.doors[i].color = 'D1'
                    } else {
                        this.doors[i].color = 'D2'
                    }
                }
            } else {
                for (let i = 0; i < 25; i++) {
                        this.doors[i].color = 'D1'
                }
            }

            //this.game.range
            // target doors
            if(this.round[j].bottom == 101){
                this.round[j].bottom = -1;
            }

        

            if (this.round[j].winningRoom == this.round[j].endGameRoom){
                //win
                this.doors[this.round[j].winningRoom].color = 'D5B'
            } else {
                // lose
                this.doors[this.round[j].winningRoom].color = 'D5C'
                this.doors[this.round[j].endGameRoom].color = 'D5A'
            }


        }
        console.log("this.collectedNeko, ", this.collectedNeko)
        console.log("this J, ", j)


        // change room that collected Neko 
        for(let i=0 ; i<this.collectedNeko.length ;  i++ ){

            if(this.collectedNeko[i].round == j){

            
                console.log("this.collectedNeko[i].door", this.collectedNeko[i].room)

                //this.doors[this.round[j].winningRoom].color = 'D5C'
                this.doors[this.collectedNeko[i].room].color = 'DNEKO'
            }

        }



        //console.log ('the grid ', this.doors)
    },

    async getURI(){
        console.log('token id :', this.metaPass);
        this.form.guardian = this.metaPass;

        if(this.metaPass < 10010){

            await contract_nft_meow.tokenURI(this.metaPass).then((res) => {
                console.log('token URI : ', res);
                this.getIMG(res);
                //this.getGuardian(this.NFT.id)
            }).catch((err) => {
                console.log(err, 'err');
            });
        }
    },        
    
    async getIMG(_url){
        const axios = require('axios');
        await axios.get(_url).then((metadata) => {
            console.log(metadata);
            console.log(metadata.data.image);
            this.nftImageURL = metadata.data.image;
            console.log('this.nftImageURL', this.nftImageURL);
            //this.nftImageURL = metadata.data.image;
        })
        .catch(function (error) {
            console.log(error);
        });
    },

    selectMetapass(_id) {
        this.metaPass = _id
        this.getURI();
        this.isMetapass = true;
        this.isOwner = true;
        console.log('selected metapass :', _id)
        
        this.isTabGame = true
        this.isTabMetapass = false

        // release hold 
        this.isPlay = true 
        this.life = 3
    },
    async getMyMetapass (){       

        await contract_nft_meow.ownedNekos().call({
            from: this.accMainnetCore,
        }).then((res) => {

            this.pumpMyPass (res);

        }).catch((err) => {
            console.log(err, 'err');
        });



    },
    async pumpMyPass (_receivedPass ){


         const axios = require('axios');
         for(let i = 0; i < _receivedPass.length; i++){

              await  contract_nft_meow.tokenURI(parseInt(_receivedPass[i])).then(res2 => {

                    axios.get(res2).then((metadata) => {
    
                        // store 
                        this.myPass.push({
                            id : parseInt(_receivedPass[i]),
                            img : metadata.data.image,
                            coolingTime : 0
                        })

                    })
                }).catch((err) => {
                    console.log(err, 'err');
                });
            }

       console.log ('My Metapassas json :', JSON.parse(JSON.stringify(this.myPass)))

       this.setCoolingTime()

    },
    async getMyMetapass2 (){       

        

            // store 
            this.myPass.push({
                id :10005,
                img : 'https://bafybeicfbnykkm4e2cziwnsakgnk4yb4a2sngvozdxmyc26btrmtdefcym.ipfs.nftstorage.link/blob',
                coolingTime : 0
            })

        await contract_nft_meow.ownedNekos().call({
            from: this.accMainnetCore,
        }).then((res) => {

            const axios = require('axios');
            for(let i = 0; i < res.length; i++){

                contract_nft_meow.tokenURI(res[i]).then((res2) => {


                    axios.get(res2).then((metadata) => {
    
                        // store 
                    
                        this.myPass.push({
                            id : parseInt(res[i]),
                            img : metadata.data.image,
                            coolingTime : 0
                        })

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
                }).catch((err) => {
                    console.log(err, 'err');
                });
            }

        }).catch((err) => {
            console.log(err, 'err');
        });

        await contract_neko.balanceOf(this.accAddress).then((res) => {
                console.log('Balance $NEKO:', (res.toString()/1e18).toFixed(2));
                this.accountNekoBalance = (res.toString()/1e18).toFixed(2);
            }).catch((err) => {
                console.log(err, 'err');
            });



    },

    changeMetapass(){
        this.isTabMetapass = true
        this.isTabGame = false
        this.dialogFishbone = false
        this.dialogMetapassExpired = false
    },

    async isMetapassOwner (){
        if( this.metaPass != 10010){

            await contract_nft_meow.ownerOf(this.metaPass).call().then((res) => {
                this.NFT.owner = res;
            })

            if (this.NFT.owner == this.accMainnetCore) {
                this.isOwner = true;
                //console.log('this is the owner');
            } else {
                //console.log('this is not the owner');
            }
        }
    },


        async getNekoTokenBalance (){      
            await contract_neko.balanceOf(this.accAddress).then((res) => {
                console.log('Balance $NEKO:', (res.toString()/1e18).toFixed(2));
                this.accountNekoBalance = (res.toString()/1e18).toFixed(2);
            }).catch((err) => {
                console.log(err, 'err');
            });
        },

        async getCFXBalance(){
                await conflux.getBalance(this.accAddress).then((res) => {
                console.log('$CFX :', (res.toString()/1e18).toFixed(2));
                this.accountCFXBalance = (res.toString()/1e18).toFixed(2);
            }).catch((err) => {
                console.log(err, 'err!!');
            });
        },

        async getNFTBalance (){
            const balance = await contract_nft_meow.balanceOf(this.accAddress);
            
            this.accountNFTBalance = balance[0];
            console.log('Total Guardian Owned:',balance); 
        },

        async getNFTDetails(){
            if(this.metaPass > 0 && this.metaPass < 10010){
            await contract_nft_meow.Nekos(this.metaPass).call().then((res) => {

                this.NFT.id           = this.metaPass;
                this.NFT.power        = res[0]; 
                this.NFT.DNA          = res[1];
                this.NFT.refCount     = parseInt(res[2]);
                this.NFT.gamma        = parseInt(res[3]);
                this.NFT.piggyBank    = parseInt(res[4].toString()/10**18).toLocaleString() ;
                this.NFT.lastPrice    = parseInt(res[5].toString()/10**18).toLocaleString() ;

                console.log('Blessing used: ', parseInt(res[2]));

                this.getGuardian()
                
            })    
            }

        },

        getGuardian (){
            this.newNFT.guardian = this.metaPass;

            // require to retrive from the metadata
            this.newNFT.guardianIMG = path_Image + this.metaPass + '.gif'
            this.form.guardian = this.metaPass;

            console.log('Guardian id : ', this.metaPass);
        },




// Retrieve General Information
    async getNeko(){

        await contract_neko.balanceOf(contract_nft_meow.address).then((res) => {
            this.poolBalance = (res.toString()/1e18).toFixed(5);
            console.log('Collectible Contract $NEKO Bal :',(res.toString()/1e18).toFixed(5));
        }).catch((err) => {
            console.log(err, 'err');
        });
    },
    async getGeneralDetails(){
        await contract_nft_meow.balanceOf(this.account).call().then((res) => {
            this.NFT.balance = parseInt(res);
            console.log('No. NFT owned :', parseInt(res));
        }).catch((err) => {
            console.log(err, 'err');
        });
    },
    checkNetworkID(){


        conflux.cfx.getId().then((res) => {
            console.log('network id: ', res);
            //console.log('async accountNekoBalance :', res);
        }).catch((err) => {
            console.log(err, 'err');
        });
    },
    async checkNekoBalance(){


        await contract_neko.balanceOf(this.account).then((res) => {
            this.accountNekoBalance = parseInt(res.toString()/1e18);
            console.log('Balance $NEKO:', (res.toString()/1e18).toFixed(2));
        }).catch((err) => {
            console.log(err, 'err');
        });


        await conflux.getBalance(this.account).then((res) => {
            console.log('DIP :', res.toString());
            console.log('$CFX :', (res.toString()/1e18).toFixed(2));
            //.div(1e18).toFixed()

        }).catch((err) => {
            console.log(err, 'err');
        });
    },

    goTabMetapass(){
        this.isTabGame = false
        this.isTabMetapass = true
    }



  }
}
</script>

<style scoped>

h2 {
    padding:5px 35px;
    color:#12bc00;
}

.maneki-logo {
    width: 200px;
}
.tab-game {
    width: 483px;
    height: 719px;
    background-image: url('../../src/assets/images/ManekiGames_bg.png');
    background-size: cover; /* Resize the background image to cover the entire container */
    border: none;
    margin:0 auto;
}
.games_details {
    border:0px solid red;
    height:180px;
    width:483px;
}
.pool_neko , .pool_cfx{
    font-size:1.5em;
    font-weight: 600;
    width: 130px;
    height: 28px;
    margin-left:80px;
    border:0px solid red;
    text-align: right;
}
.pool_neko{
    padding-top: 35px;
}
.live-display {
    font-size:1.5em;
    font-weight: 600;
    width: 90px;
    height: 28px;
    margin-left:355px;
    margin-top:-14px;
    text-align: center;

}

.latestWinner {
    font-size:1.5em;
    font-weight: 600;
    width: 90px;
    height: 28px;
    margin-left:280px;
    margin-top: -110px;
    border:0px solid red;
    text-align: center;
    padding-top:10px;
}
.panel-play{
    border:0px solid red;
    height:539px;
    width:483px;
    background-image: url('../../src/assets/images/ManekiGames_upper.png');
    background-size: cover; /* Resize the background image to cover the entire container */

}
.metapass_status {
    float: left;
    margin-left:64px;
    margin-top:41px;
    color: black;
    background: white;
    height:37px;
    width:166px;
    text-align: center;
    vertical-align:middle;
    line-height: 33px;
}
.round_details{
    height:85px;
    width:483px;
    border:0px solid red;
}
.win_count{
    height:76px;
    line-height: 130px;
    width:135px;
    background-image: url('../../src/assets/images/ManekiGames_big-lucky-fish.png');
    background-repeat: no-repeat;
    background-position: left;
    text-align: right;
    font-size:1.5em;
    float:right;
    margin-right:103px;
    margin-top:-32px;
}
.tokenDebit {
    height:30px;
    width:100px;
    text-align: right;
    font-size:1.3em;
    padding-top:50px;
    margin-left:240px;
    color: #12bc00;
    font-weight: 600;
}
.doors {
    width:435px;
    list-style: none;
    color:#000;
    margin: 0;
    padding: 0 24px;
}
.doors li {
    border: 1px solid #12bc00;
    text-align: center;
    line-height: 85px;
    vertical-align: middle;
    width:85px;
    height:85px;
    float:left;
}









.D0 {
    background: #0086ff;
}
.D1 {
    background: #eaeaea;
    color : #eaeaea;
}
.D2 {
    background: white;
}
.D3 {
    background: black;
}
.D4 {
    background: white;
    color: green;
}
.D5A {
    background-image: url('../../src/assets/images/ManekiGames_icon-lose.png');
    background-repeat: no-repeat;
    color : transparent;
    background-color: #494949;
}
.D5B {
    background-image: url('../../src/assets/images/ManekiGames_icon-win.png');
    background-repeat: no-repeat;
    color : transparent;
    background-color: #12bc00;
}
.D5C {
    background-image: url('../../src/assets/images/ManekiGames_icon-win.png');
    background-repeat: no-repeat;
    color : transparent;
}
.DNEKO {
    background-image: url('../../src/assets/images/ManekiGames_icon-nekotoken.png');
    background-repeat: no-repeat;
    color : transparent;
}

h1{
    width: 25%;
    font-size: 2em;
    color:rgba(255, 255, 0, 0.7);
    margin:0 auto;
    font-weight: 100;
    margin-bottom: 20px;
    text-align: center;
}

.content-tab{
    padding-top: 10px;
    width:500px;
    min-height:130px;
    margin:0 auto;
    border:0px solid red;
}
.title-tab img {
    float:left;
    width: 100px;
    padding:10px;
}
.title-tab h1 {
    float:left; 
    text-align: left;
    width: 400px;
    padding:10px;
}
.tab-metapass {
    color:black;
    width: 483px;
    min-height: 530px;
    background: white;
    border: none;
    border-radius: 20px;
    margin:0 auto;
}


.tab-metapass ul {
    padding:20px;
    margin:0 auto;
    width:420px;
}
.tab-metapass li{
    width:180px;
    height: 220px;
    opacity: 1;
    list-style: none;
    color: black;
    border: 1px solid #12bc00;
    border-radius: 5px;
    float:left;
    margin-right:15px;
    margin-bottom: 30px;
    padding:5px;
}


.tab-koban {
    color:black;
    width: 483px;
    height: 530px;
    float:right;
    background: #3fc600;
    border: none;
    border-radius: 20px;
    margin: 0 5px;
    margin-bottom:100px;
}
.koban-winners{
    
}
.koban-winners ul {
    padding:20px;
    margin:0;
}
.koban-winners li{
    opacity: 1;
    list-style: none;
    color: white;
    background: #ffc200;
    border-radius: 50px;
    padding:5px 30px;
    margin: 10px 0;
}
.koban-winners a:link {
  text-decoration: none;
}


.dialog-container {
    width:1000px;
    min-height: 1000px;
    margin:0 auto;
}

.dialog-wrap {
    border:1px solid red;
    min-height: 300px;
    text-align: center;
    font-size:3em;
    color:black;
    background: white;
    border-radius: 20px;
}
.dialog-wrap img {
    width:200px;
}
.el-icon-picture{
    width:195px;
    height: 95px;
    background-image: url('../../src/assets/images/slot-in.png');
}

.el-icon-picture:before {
    content:none;
}
.gashapon{
    width:293px;
    height:462px;
    background-image: url('../../src/assets/images/gashapon.png');
    margin: 0 auto;
}
.gashapon:hover{
    width:293px;
    height:462px;
    background-image: url('../../src/assets/images/gashapon.png');
    margin: 0 auto;
    margin-top : 3px;
}
.el-button--gashapon {
    background-color: yellow;
    color:tomato;
    border: 1px solid tomato;
}
.dialog-input-wrap{
    width:500px; 
    height:420px;
    margin:0 auto; 
    padding-bottom:15px; 
    padding-top:20px; 
    padding-left:20px; 
    padding-right:20px; 
    border:1px solid #000;  
    background:rgba(0, 0, 99, 0.8);  
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    border-radius: 5px;
}
.dialog-content{
    height:300px;
}
.dialog-footer-msg{
    color:white;
}
.btn_twister{
    cursor: pointer;
}

.btn_twister:hover{
  -webkit-transform:rotate(110deg);
  -moz-transform: rotate(110deg);
  -ms-transform: rotate(110deg);
  -o-transform: rotate(110deg);
  transform: rotate(110deg);
}

.dailog_payment {
    text-align: center;
}
.dialog-footer {
    text-align: center;
}
.dialog-footer a{
    text-decoration: none;
    color:#ff3600;;
    padding:5px;
}
.el-dialog {
}
.wallet-connection{
    width: 460px;
    text-align: right;
    color: #c6c6c6;
    float:right;
    margin-right:30px;
}
.token-wrap{
    width: 460px;
    height: 30px;
    padding:20px;
    margin-top:-20px;
    background: #3f3f3f;
    border-radius: 0 0 10px 10px;
    background:rgba(0, 0, 0, .4); 
    border:solid 1px #0086ff;
}
.cfx-balance {
    text-align: left;
    background-image: url("../../src/assets/images/icon-cfx.png");
    background-repeat: no-repeat;
    background-position: top left; 
    background-size : 23px 23px;
    padding:2px;
    padding-left:30px;
    padding-right:5px;
    min-height: 27px;
    width:140px;
    float:left;
    color:white;
}
.neko-balance {
    text-align: left;
    background-image: url("../../src/assets/images/icon-neko.png");
    background-repeat: no-repeat;
    background-position: top left; 
    background-size : 23px 23px;
    padding:2px;
    padding-left:30px;
    padding-right:5px;
    min-height: 27px;
    width:140px;
    color:#fcee21;
    float:left;
}
.meow-balance {
    text-align: left;
    line-height:27px ;
    vertical-align: middle;
    background-image: url("../../src/assets/images/icon-meow.png");
    background-repeat: no-repeat;
    background-position: 0px 5px; 
    background-size : 23px 23px;
    padding:2px;
    padding-left:30px;
    padding-right:5px;
    min-height: 27px;
    width:60px;
    float:right;
    color:black;
}
</style>